import { FC } from 'react';

import { useActionsData } from '../hooks/useActionsData';
import { STICKY_PAGE_ACTIONS_TEST_ID } from '../test-ids';
import { ActionButton } from './ActionButton';
import { StickyWrapper } from './StickyPageActions.styles';

export const StickyPageActions: FC = () => {
    const { actions, bottomOffset } = useActionsData();

    if (!actions.length) {
        return null;
    }

    return (
        <StickyWrapper $bottomOffset={bottomOffset} data-test={STICKY_PAGE_ACTIONS_TEST_ID.WRAPPER}>
            {actions.map((action) => (
                <ActionButton key={action.id} action={action} />
            ))}
        </StickyWrapper>
    );
};
